import { ListSort } from 'common/types/entities/list'
import { getFirstFetchSort, Sort, SubVertical } from 'common/constants'
import { StateKey } from 'common/utils/flipState'
const initialState: ListSort = {
  sort: null,
  isOpened: false,
}

const SET_SORT = '/list/sort/SET_SORT'
const OPEN_CLOSE_SORT = '/list/sort/OPEN_CLOSE_SORT'

export const initSort = (curState: StateKey, subVertical: SubVertical, queryParams?: any) => {
  const initialSort = queryParams && queryParams['sort'] && queryParams['sort'] in Sort ? queryParams['sort'] : null

  return {
    curState,
    sort: initialSort || getFirstFetchSort(subVertical),
    type: SET_SORT,
    isOpened: false,
  }
}

export const setSort = (curState: StateKey, sort: Sort) => {
  return {
    curState,
    sort,
    type: SET_SORT,
    isOpened: false,
  }
}

export const openAndCloseSort = (curState: StateKey, isOpened: boolean) => {
  return {
    curState,
    isOpened,
    type: OPEN_CLOSE_SORT,
  }
}

const sortReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SORT:
      return { sort: action.sort, isOpened: action.isOpened }
    case OPEN_CLOSE_SORT:
      return { ...state, isOpened: action.isOpened }
    default:
      return state
  }
}

export default sortReducer
